import createTypography from "@mui/material/styles/createTypography";

import { palette } from "./palette";

export const typography = createTypography(palette, {
  fontFamily: "PolySans",
  h1: {
    fontSize: "4.5rem",
    lineHeight: 1.25,
  },
  h2: {
    fontSize: "3.5rem",
    lineHeight: 1.25,
  },
  h3: {
    fontSize: "2rem",
    lineHeight: 1.25,
  },
  h4: {
    fontSize: "1.5rem",
    lineHeight: 2,
  },
  h5: {
    fontSize: "1.25rem",
    lineHeight: 1.4,
  },
  h6: {
    fontSize: "1.125rem",
    lineHeight: 1.5,
    fontWeight: 400,
  },
  body1: {
    fontSize: "1.25rem",
    lineHeight: 1.4,
  },
  // text M
  body2: {
    fontSize: "1.125rem",
    lineHeight: 4 / 3,
  },
  subtitle1: {
    fontSize: "1rem",
    lineHeight: 1.25,
    color: palette.text.secondary,
  },
  subtitle2: {
    fontSize: "1rem",
    lineHeight: 1.25,
  },
  button: {
    fontSize: "1.25rem",
    lineHeight: 1.2,
  },
});
